import React, { useState, useEffect, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import { responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, buttonProcessGet, awaitDelay, isNumber, isUndNull } from '../../helpers/settings'
import { conceptModelGet } from '../../models/expenses/concept';
import { GlobalFormats } from '../../classes/main/globalFormats';
import axios from 'axios';

const currentMethod = 'ConceptAddEdit';

//const { app, collections: dbColle, colors, icons, labels, messages, react, } = globalSettings;
const { app, collections: dbColle, icons, images, labels, messages, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
// const { operators: dbOpera, } = react?.firebase;

export default function ConceptAddEdit({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    concept = conceptModelGet({}),
    setConcept = () => { },
    expenseConceptTypes = [],
    setExpenseCenceptTypes = () => { },
    processValues = {
        dtId: '',
        dtRowIndex: 0,
        type: 0,
    },
    setProcessValues = {},
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    const [typeError, setTypeError] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalExpenseConceptSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalExpenseConceptBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalExpenseConceptClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalExpenseConceptSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalExpenseConceptBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalExpenseConceptName',
                className: 'form-control',
            },
            // model: {
            //     id: 'inputModalExpenseConceptModel',
            //     className: 'form-control',
            // },
            // manufactured: {
            //     id: 'inputModalExpenseConceptManufactured',
            //     className: 'form-control datetimepicker-input',
            // },
            // serial: {
            //     id: 'inputModalExpenseConceptSerial',
            //     className: 'form-control',
            // },
            // type: {
            //     id: 'inputModalExpenseConceptType',
            //     className: 'form-control',
            // },
            // cost: {
            //     id: 'inputModalExpenseConceptCost',
            //     className: 'form-control text-right',
            // },
        },
        // radios: {
        //     even: {
        //         id: 'radioModalExpenseConceptEven',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        //     odd: {
        //         id: 'radioModalExpenseConceptOdd',
        //         className: 'icheck-primary d-inline',
        //     },
        //     both: {
        //         id: 'radioModalExpenseConceptBoth',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        // },
        selects: {
            type: {
                id: 'selModalExpenseConceptType',
                className: 'form-select',
            }
        },
        spinners: {
            save: {
                id: 'spModalExpenseConceptSave',
                className: '',
            },
            back: {
                id: 'spModalExpenseConceptBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            await errosDefaultSetAsync({ subMethod: currentMethod, });

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setConcept({ ...concept, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: concept?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNull({ data: concept?.type, subMethod: currentMethod, })?.result ||
                !isNumber({ number: concept?.type, languageId: languageObj?.id, subMethod: currentMethod, })?.result ||
                concept?.type <= 0) {
                setTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                expenseConcept: concept,
                languageId: [languageObj?.id],
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: [languageObj?.id],
                    subMethod: currentMethod,
                });
                return;
            }

            concept = response?.result;
            //#endregion data save

            //#region save dataTable
            const processButtonLocal = [
                {
                    isVisible: true,
                    showDivider: true,
                    isEnabled: true,
                    methodName: backend?.methods?.showVariations,
                    icon: icons?.chartLine,
                    label: labels?.variations?.[languageObj?.id],
                }
            ];

            $(`#${processValues?.dtId}`)?.DataTable()?.row?.add([
                concept?.description,
                expenseConceptTypes?.find(({id}) => id === concept?.type)?.description || '',
                buttonProcessGet({
                    id: concept?.id,
                    description: concept?.description,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: processButtonLocal,
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion save dataTable

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
    }

    const conceptEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region expense concept save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                expenseConcept: concept,
                languageId: [languageObj?.id],
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/${concept.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: [languageObj?.id],
                    subMethod: currentMethod,
                });
                return;
            }

            concept = response?.result;
            //#endregion expense concept save

            //#region expense concept dataTable update
            const processButtonLocal = [
                {
                    isVisible: true,
                    showDivider: true,
                    isEnabled: true,
                    methodName: backend?.methods?.showRates,
                    icon: icons?.chartLine,
                    label: labels?.variations?.[languageObj?.id],
                }
            ];

            $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.dtRowIndex)?.data?.([
                concept?.description,
                expenseConceptTypes?.find(({id}) => id === concept?.type)?.description || '',
                buttonProcessGet({
                    id: concept?.id,
                    description: concept?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: processButtonLocal,
                    subMethod: currentMethod,
                })?.result,
            ])?.draw();
            //#endregion expense concept dataTable update

            setProcessValues({ ...processValues, dtRowIndex: 0, type: 0, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: [languageObj?.id],
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.name?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.applicants?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.applicants?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataSetAsync({ subMethod: 'form - onLoad', });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - header', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.concept?.[languageObj?.id]}
                        src={images?.expenseConceptsLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {labels?.concept?.[languageObj?.id]} ({processValues?.type === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : labels?.edit?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btn - close', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.type === 0 ?
                conceptAddPostAsync({ e, subMethod: 'form - onSubmit' }) :
                conceptEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processValues?.type === 0 ? conceptAddPostAsync(e) : conceptEditPostAsync(e)}> */}

                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.concept?.[languageObj?.id]}
                                    src={images?.expenseConceptsLogo}
                                    style={styles?.cardHeaderLogo}>
                                </img> - {labels?.concept?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.name?.id}
                                className={controls?.inputs?.name?.className}
                                //autoFocus
                                placeholder={labels?.name?.[languageObj?.id]}
                                onChange={(e) => formDataSetAsync({ property: 'description', value: e?.target?.value, subMethod: 'input - name', })}
                                onFocus={() => setDescriptionError('')}
                                value={concept?.description || ''}
                                tooltip='tooltip'
                                title={labels?.name?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.spellCheck} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <select id={controls?.selects?.type?.id}
                                className={controls?.selects?.type?.className}
                                value={`${concept?.type}` || '0'}
                                onChange={(e) => formDataSetAsync({
                                    property: dbProps?.type,
                                    //#region old code
                                    // value: !isNumber({
                                    //     number: e?.target?.value,
                                    //     languageId: languageObj?.id,
                                    //     subMethod: 'input - type',
                                    // })?.result ?
                                    //     0
                                    //     :
                                    //     parseInt(e?.target?.value),
                                    //#endregion old code
                                    value: parseInt(e?.target?.value),
                                    subMethod: 'input - type',
                                })}
                                onFocus={() => setTypeError('')}>
                                <option key='0'
                                    value='0'>{messages?.selectType?.[languageObj?.id]}</option>
                                {expenseConceptTypes?.map((type) => <option key={`${type?.id}`} value={`${type?.id}`}>{type?.description}</option>)};
                            </select>
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.listAlt} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(typeError)}</div>
                    </div>
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip' title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer className='card-footer'>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btn - back', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}